import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { angela } from "../characters/Angela";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { tom } from "../characters/Tom";
import { vanessa } from "../characters/Vanessa";
import { doPutMultipleImages, doTransition, doWaitImageByTime, isFollowingVanessaLead } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaMCBeachAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import SoundClass from "../../src/shell/Sound";
import { music } from "./sounds";


export const V8VanessaMCBeach = async (): Promise<any> => {
    doTransition(images.v8.V8VanessaMCBeach_0);
    // SoundClass.startMusic(music.V8VanessaMCAngelaBeach, { shouldPlay: true, loop: true });
    vanessa.talk(`Here we are.`);
    angela.talk(`Wow. This place is really secluded!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_1);

    vanessa.talk(`I told you I know the best spots in town!`);
    angela.talk(`Yes, this place is really cool!`);
    angela.talk(`We were in such a hurry we didn't have a chance to switch into our bathing suits...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_2);
    vanessa.talk(`That's not a problem! You can change behind that rock.`);
    angela.talk(`Ah...`);
    vanessa.talk(`As you said, this place is really secluded, no one will see you.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_1);
    angela.talk(`Ok! I'll do it!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_3);
    angela.talk(`Let me just get our swimwear...`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_4);
    angela.talk(`Ok, we'll be back in a bit!`);
    vanessa.talk(`Take your time, we'll be right here!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_5);
    mc.talk(`Finally we are alone.\nCan you tell me what the hell are you planning?`);
    vanessa.talk(`Are you sure you want to know? I figured it will be easier if you'd just play along.`);
    mc.talk(`I rather be in the loop, just tell me.`);
    vanessa.talk(`As you wish.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_6);
    vanessa.talk(`So basically, you are going to fuck her while I take some photos and we'll show them to the creepy grandpa so he'll get off my back.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_8);
    mc.talk(`What the actual fuck? Are you serious?`);
    mc.talk(`How are you going to manage that? She is literally here with her boyfriend.`);
    mc.talk(`Plus, didn't you think about asking me if I was comfortable with that?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_7);
    vanessa.talk(`Are you complaining about fucking some chick?`);
    vanessa.talk(`She is pretty hot! I'd definitely do her! It's not like I asked you to take one for the team and hook up with some monster.`);
    if (isFollowingVanessaLead()) {
        vanessa.talk(`And let's not forget our little bet, you agreed to follow my lead!`);
        if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy === false) {
            vanessa.talk(`You already fucked up by not fucking that big guy's girlfriend. So you owe me double!`);
        } else {
        }

    } else {
        ImageClass.setImage(images.v8.V8VanessaMCBeach_8);
        mc.talk(`Correct me if I'm wrong, but didn't we agree you'd follow my lead?`);
        mc.talk(`So far, it doesn't seem like that is what is happening.`);
        ImageClass.setImage(images.v8.V8VanessaMCBeach_7);
        vanessa.talk(`I will follow your lead, but this is a special circumstance, we were in this situation before we made our bet.`);
        vanessa.talk(`And this is our chance to finish it once and for all!`);
    }

    mc.talk(`Let's assume that I agree, how the hell am I going to fuck her with her boyfriend standing right here?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_9);
    vanessa.talk(`Have you seen him? He is basically a vegetable.`);
    vanessa.talk(`If I didn't know better I would think he has brain damage.`);
    mc.talk(`Even so, I don't think he'll just sit back and watch as I nail his girl.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_10);
    vanessa.talk(`Listen, the only hard part was getting them to come here.`);
    vanessa.talk(`From now on it should be smooth sailing.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_10.partials.V8VanessaMCBeach_86);
    vanessa.talk(`I know girls like her. She is trying to act all goody two shoes, but she has a wild side inside of her.`);
    await vanessa.setQuestion(new Question({ text: `And didn't you see how she looks at me? She is already admiring me, it's going to be a piece of cake.`, options: { think: false }, key: `v8VanessaHesitatedOnVanessaPlan` })
        .option({ title: `Agree with Vanessa`, key: false })
        .option({ title: `Hesitate`, key: true }));


    doWaitImageByTime(images.v8.V8VanessaMCBeach_87);
    if (Question.globalAnswers.v8VanessaHesitatedOnVanessaPlan) {
        mc.talk(`I'm not sure about that.`);
        mc.talk(`She's seems like a good girl, this might destroy her.`);
        doWaitImageByTime(images.v8.V8VanessaMCBeach_11.partials.V8VanessaMCBeach_11_p, { putParent: true });
        vanessa.talk(`Or free her!`);
        vanessa.talk(`No one would ever see the pictures besides her grandpa and us!`);
        vanessa.talk(`It's not like I'm going to post them all over the internet. What do you take me for? I'm not a monster!`);
        doWaitImageByTime(images.v8.V8VanessaMCBeach_11);
        mc.talk(`Let's assume I'm on board, what do you need me to do?`);

    } else {
        mc.talk(`From what I've seen, you are right.`);
        vanessa.talk(`Of course I am!`);
        mc.talk(`So what's my role? What am I suppose to do?`);
    }

    doWaitImageByTime(images.v8.V8VanessaMCBeach_11.partials.V8VanessaMCBeach_11_p, { putParent: true });
    vanessa.talk(`Just sit back, relax, and let me get her ready.`);
    vanessa.talk(`Once she is, just slide in and enjoy yourself!`);

    mc.talk(`You are crazy, you know that right?`);
    vanessa.talk(`What else is new?`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_11);
    vanessa.talk(`Well...?`);
    mc.talk(`Well what?`);
    // TODO: hehehe
    ImageClass.setImage(images.v8.V8VanessaMCBeach_11.partials.V8VanessaMCBeach_11_p);
    vanessa.talk(`Are you going to take off your clothes or what?`);
    vanessa.talk(`You can't be the only one dressed. Kinda defeats the purpose.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_11);
    mc.talk(`Yeah, sure, I was just busy listening to your master plan.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_12);
    vanessa.talk(`Oh wow, you are already good to go!`);
    vanessa.talk(`Hold that boner!`);




    return jump(V8VanessaMCBeach_2, "V8VanessaMCBeach_2");
};
export const V8VanessaMCBeach_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8VanessaMCBeach_13);
    vanessa.talk(`Here they come!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_14);
    vanessa.talk(`Oh wow! Look at you! Looking hot!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_17);

    angela.talk(`Haha, come on stop it!`);
    vanessa.talk(`I'm serious! You have a killer body.`);
    angela.talk(`I wish it was as good as yours, but thank you!`);

    return jump(V8VanessaMCBeach_3, "V8VanessaMCBeach_3");
};

export const V8VanessaMCBeach_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8VanessaMCBeach_16);
    vanessa.talk(`Hey guys. Would you mind if I go topless?`);
    vanessa.talk(`I just hate those tan lines!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_15);
    angela.talk(`Eh... I don't mind...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p);
    vanessa.talk(`${tom.name}?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p_2);
    tom.talk(`I don't mind either.`);
    mc.think(`Oh, he has the ability to talk.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_19);
    vanessa.talk(`You guys are great!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_18);
    mc.think(`Look at her, she's so proud of herself...`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_19);
    mc.think(`The way they both are looking at her taking off her top.`);
    mc.think(`You can tell they haven't met anyone like her before. I definitely know how they feel.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_20);

    mc.think(`Oh... Busted!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_21);
    mc.think(`But she did say she don't mind Vanessa going topless. So it's obvious he'd look...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`Much better!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23);
    vanessa.talk(`What about you?`);
    angela.talk(`Who? Me? Oh no! I would never.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23.partials.V8VanessaMCBeach_23_p);
    vanessa.talk(`Yeah, I know. I was just joking.`);
    angela.talk(`Oh...`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_26, null, 2);
    empty.think(`Some time passes.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_27, { wait: true, duration: 1 });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_28);
    angela.talk(`Isn't it weird?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`Weird how?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23);
    angela.talk(`That people are staring at your... intimate parts.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`It's just fat.`);
    vanessa.talk(`Besides it's all the same, some are bigger, some are smaller. I don't see what the big deal is.`);
    angela.talk(`Yeah... That makes sense.`);
    // silent
    doWaitImageByTime(images.v8.V8VanessaMCBeach_26, null, 2);
    empty.think(`More time passes...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_28);
    angela.talk(`When was the first time you went topless?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`I was at the beach and saw a bunch of girls sunbathing topless, and it seemed pretty cool so I took off mine as well.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23);
    angela.talk(`Weren't you ashamed?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`No.`);
    vanessa.talk(`I don't know about you, but I like the attention.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23);
    angela.talk(`I also like attention...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`Most girls do. Haha.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_26, { wait: true, duration: 1.5, hideText: true });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_27, { wait: true });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_29);
    angela.talk(`How does it feel?`);
    mc.think(`She is obviously curious...`);
    // TODO: maybe add another render similar to _22 for variety
    ImageClass.setImage(images.v8.V8VanessaMCBeach_22);
    vanessa.talk(`Like freedom.`);
    vanessa.talk(`The feeling of the sun's warmth on my breasts is something I'm addicted to.`);
    mc.think(`That's not a lie...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_24);
    angela.talk(`${mc.name}? Doesn't it bother you that people watch her?`);
    mc.talk(`Ah...`);
    vanessa.talk(`Of course it doesn't!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_23);
    vanessa.talk(`People can look as much as they want, but at the end of the day. I go home with him.`);
    mc.think(`Debatable...`);
    doPutMultipleImages([images.v8.V8VanessaMCBeach_15, images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p, images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p_3]);
    angela.talk(`${tom.name}. Do you think less of Vanessa now?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p_2);
    tom.talk(`No. Of course not!`);

    doPutMultipleImages([images.v8.V8VanessaMCBeach_15, images.v8.V8VanessaMCBeach_15.partials.V8VanessaMCBeach_15_p_3]);
    vanessa.talk(`See.`);
    angela.talk(`Yeah...`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_29);
    vanessa.talk(`But as I said. It's not something most girls would do.\nYou need a certain kind of character...`);
    mc.think(`Come into my parlour said the spider to the fly... Damn Vanessa is a natural at this.`);
    // silent.
    doPutMultipleImages([images.v8.V8VanessaMCBeach_83, images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2]);
    angela.talk(`What do you say?`, { method: "Whispering" });

    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p, { putParent: true });
    tom.talk(`About what?`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2);
    angela.talk(`If I try it...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p, { putParent: true });
    tom.talk(`Are you serious?`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2);
    angela.talk(`Kinda...`, { method: "Whispering" });
    angela.talk(`We always talk about trying new...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p, { putParent: true });
    tom.talk(`We do, but I wasn't expecting this here and now.`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2);
    angela.talk(`I won't do something you wouldn't like...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p, { putParent: true });
    tom.talk(`I mean... If you want to.`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2);
    angela.talk(`Wouldn't you mind that ${mc.name} would see me?`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p, { putParent: true });
    tom.talk(`Mmm... Vanessa does have a point...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_83.partials.V8VanessaMCBeach_83_p_2);
    angela.talk(`I know. I was thinking the same thing.`, { method: "Whispering" });


    // taking off shirt
    doWaitImageByTime(images.v8.V8VanessaMCBeach_30, { wait: true });
    doWaitImageByTime(images.v8.V8VanessaMCBeach_31, { wait: true }, 1.5);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_32);
    vanessa.talk(`Wow you really did it!`);
    vanessa.talk(`How does it feel?`);
    angela.talk(`Weird... But in a good way. I can understand what you were talking about now.`);
    vanessa.talk(`You are full of surprises, aren't you?`);
    angela.talk(`Haha...`);
    vanessa.talk(`I guess I was too early to judge! Well played!`);
    vanessa.talk(`Well, now you can lie back and relax.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_33);
    vanessa.talk(`How does it feel now?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_34);
    angela.talk(`Like freedom...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    angela.talk(`It feels better than I expected.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_37);
    vanessa.talk(`I'm glad you gave it a try.`);
    angela.talk(`Me too!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_35, { wait: true });

    // vanessa.talk(`Besides, you are going to thank me once you get home. You are going to have the best sex you've ever had.`);
    // ImageClass.setImage(images.v8.V8VanessaMCBeach_34);
    // vanessa.talk(`You are having sex right?`);
    // ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    // angela.talk(`Of course we do!`);
    // angela.talk(`And why do you say that?`);
    // vanessa.talk(`You'll see...`);
    // Silent
    ImageClass.setImage(images.v8.V8VanessaMCBeach_36);
    vanessa.talk(`By the way, how long have you guys been dating?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_37);
    angela.talk(`For four years now.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    angela.talk(`We met in high school.`);
    angela.talk(`And we graduated two years ago.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_37);
    vanessa.talk(`Hope you don't mind me asking, but is it fair to say you've both always been with each other?`);
    // doWaitImageByTime(images.v8.V8VanessaMCBeach_40);
    angela.talk(`Yes.`);
    vanessa.talk(`Oh really? Same as me and ${mc.name}!`);
    mc.think(`...`);
    angela.talk(`Oh wow! I wonder what else we have in common!`);
    vanessa.talk(`Well, for us it's a bit different though.`);
    vanessa.talk(`We are in an open relationship.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    angela.talk(`Wow... Really?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_37);
    angela.talk(`I've heard of that before, but I've never met a couple that actually do that!`);
    vanessa.talk(`Nice to meet you!`);
    angela.talk(`Haha!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    angela.talk(`How does it work exactly?\nAre you together and also dating other people?`);
    angela.talk(`Do you ask for permission before going out with someone else?`);
    angela.talk(`Do you hook up with other people together or separate?`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_37);
    vanessa.talk(`So many questions, so little time...`);
    vanessa.talk(`Basically we are together as a couple and only sleeping with other people.`);
    angela.talk(`Oh...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_35);
    vanessa.talk(`Think of it in this way:`);
    vanessa.talk(`Normal couples go on a date, they have fun, laughing and drinking, doing all sort of things.`);
    vanessa.talk(`During the date the guy sees a hot girl. She is exactly his type, but he tries not to look so his girl won't notice.`);
    vanessa.talk(`The night continues and they get back home.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_36);
    vanessa.talk(`The only thing on the guy's mind is that random girl he just saw.`);
    vanessa.talk(`Suddenly his girl has flaws that the other girl doesn't.`);
    vanessa.talk(`And he only had a glance of her.`);
    vanessa.talk(`The guy is still young, he thinks he can do better...`);
    vanessa.talk(`One thing leads to another and they break up, just for the guy to never find that one girl ever again.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_38);
    vanessa.talk(`But for couples like us the story is a bit different.`);
    vanessa.talk(`The guy can approach the girl and fuck her.`);
    vanessa.talk(`That's if he succeeds in convincing her of course.`);
    vanessa.talk(`Once he does, he comes back home to me and we have wild, passionate sex.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_39);
    angela.talk(`I see your point.`);

    vanessa.talk(`But beyond that there is also only so much you can learn from a single partner.`);
    vanessa.talk(`But I'm not worrying about you! You seem like you have a strong relationship! You'll beat the statistic.`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_40);
    angela.talk(`Statistic? What statistic?`);
    vanessa.talk(`Most couples that are dating since high school won't get married.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_43);
    vanessa.talk(`It's just a chapter in their lives before they meet their life partner.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_42);
    vanessa.talk(`If you ask me, it's a pity, because they could have been a better fit.`);
    vanessa.talk(`But that is how it plays out for nearly all of them.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_43);
    vanessa.talk(`But again, you guys are an amazing couple! Even though it's hard, you can make it.`);
    vanessa.talk(`There are also methods that can help you out.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_42);
    angela.talk(`What methods?`);
    vanessa.talk(`It's actually pretty easy, but I don't know if it's the time or the place.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_41);
    angela.talk(`Why not? We'd love to learn, I bet ${tom.name} thinks the same... Right ${tom.name}?`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_42);
    tom.talk(`Yes, please teach us.`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_45);
    vanessa.talk(`Alright, the most important thing is to relax and follow my lead.`);
    vanessa.talk(`I don't do this for anyone. I honestly like you two and I want it to work for you!`);

    angela.talk(`I'm ready! How do we start?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_46);
    vanessa.talk(`First I need to experience what ${tom.name} is experiencing.`);
    angela.talk(`Ah...`);
    vanessa.talk(`Both of you can stop at any point if you don't feel comfortable.`);
    vanessa.talk(`Ready?`);
    angela.talk(`Y... Yeah.`);

    // Kissing
    ImageClass.setImage(images.v8.V8VanessaMCBeach_47);
    angela.talk(`Mmm... `);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_48);
    mc.think(`Wow! What a manipulative girl.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_49);
    vanessa.talk(`How did that feel?`, { method: `Soft Voice` });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_50);
    angela.talk(`A... Amazing...`);
    vanessa.talk(`Do you think you can replicate it yourself?`, { method: `Soft Voice` });
    angela.talk(`I might... Where is ${tom.name.slice(0, 1)}...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_51);
    vanessa.talk(`No... Not on him.`, { method: `Soft Voice` });
    vanessa.talk(`You need someone that can tell you if you are doing it right.`, { method: `Soft Voice` });

    angela.talk(`Oh...`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_52);
    mc.think(`This is my queue...`);
    await mc.setQuestion(new Question({ text: `Do I want to help Vanessa take advantage of this girl just to get back at her grandfather...?`, options: { think: true }, key: `v8FuckedAngela` })
        .option({ title: `Do it`, key: true })
        .option({ title: `Don't do it`, key: false }));


    if (Question.globalAnswers.v8FuckedAngela) {

        return jump(V8VanessaMCBeach_FuckAngela, "V8VanessaMCBeach_FuckAngela");

    }


    return jump(V8VanessaMCBeach_DontFuckAngela, "V8VanessaMCBeach_DontFuckAngela");
};
export const V8VanessaMCBeach_FuckAngela = async (): Promise<any> => {
    mc.think(`Of course I do!`);
    mc.think(`Besides, Vanessa promised me that her pictures won't see the light of day.`);
    mc.think(`And it's not like we are doing it against her will, she's agreeing to it.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_53);
    vanessa.talk(`Now, relax, close your eyes, and just try to do the same as I did.`);
    vanessa.talk(`Go for it.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_54);
    angela.talk(`Mmm...  `);
    mc.think(`Wow she is actually a good kisser.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_55);
    mc.think(`I haven't kissed Vanessa so I don't know if she was already a good kisser or actually picked it up from Vanessa right now.`);
    tom.talk(`A...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_56);
    vanessa.talk(`I hope you aren't jealous.`);
    vanessa.talk(`She is doing this for you.`);
    tom.talk(`I mean... This is going a bit too far.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_57);
    vanessa.talk(`Look at me.`);
    tom.talk(`...`);
    vanessa.talk(`You can stop it whenever you want, but once you do, there is no way of going back.`);
    tom.talk(`Ok... I'll let it continue for a bit more...`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_56);
    vanessa.talk(`Believe me, you are making a wise choice.`);

    // all three are kissing.
    doWaitImageByTime(images.v8.V8VanessaMCBeach_58);
    angela.talk(`...`);
    mc.think(`${angela.name}'s breath is getting stronger and stronger.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_59);
    mc.think(`She can stop, but she chooses to continue.`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_60);
    vanessa.talk(`Don't hold yourself back.`, { method: `Soft Voice` });
    vanessa.talk(`You know what you want.`, { method: `Soft Voice` });

    mc.think(`She is not resisting...`);

    tom.talk(`Vanessa?`);
    // in front of tom
    doWaitImageByTime(images.v8.V8VanessaMCBeach_61);
    tom.talk(`I think we should stop it.`);
    vanessa.talk(`Be my guest, but at this point, it will cause more harm than good.`);
    vanessa.talk(`She can also stop it, but she chooses to continue.`);
    vanessa.talk(`Stopping it right now will only make her wonder what could have happened.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_62);
    tom.talk(`I... I... But... Look at them.`);
    vanessa.talk(`I understand you completely! It's also my boyfriend there.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_61);
    vanessa.talk(`Relax, they are going to stop any minute now.`);


    doWaitImageByTime(images.v8.V8VanessaMCBeach_63);
    tom.talk(`Now it's definitely gone too far...`);
    angela.talk(`Ahh!!!`);
    tom.talk(`She is enjoying it...`);
    vanessa.talk(`And you want to prevent it?`);
    vanessa.talk(`Go on, be my guest.`);
    doWaitImageByTime(images.v8.Anim_MCAngelaDoggy.poster, { wait: true });
    ImageClass.setAnimation(images.v8.Anim_MCAngelaDoggy);
    angela.talk(`Oh my God!`);
    angela.talk(`Yes!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_65);
    empty.think(`*Click*`);
    tom.talk(`What are you doing?`);
    vanessa.talk(`Capturing the moment.`);
    mc.talk(`Ahhh!!!`);
    vanessa.talk(`Not there! Turn around!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_66);
    vanessa.talk(`That's better!`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_68, { duration: 1, wait: 0.5 });
    mc.talk(`Ahh!!`, { wait: 0.1 });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_68, { wait: 0.5 });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_69, { wait: true });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_71);
    angela.talk(`Wow...`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_70);
    vanessa.talk(`Hey, honey. Look at me.`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_72);
    angela.talk(`What are you doing?`);

    vanessa.talk(`Don't worry, I'm just gonna send them to you and delete them right after.`);
    angela.talk(`Haha, ok.`);
    vanessa.talk(`Give me a wide smile!`);
    // TODO: match the phone photos to the scene photos
    ImageClass.setImage(images.v8.V8VanessaMCBeach_73);
    vanessa.talk(`Perfect!`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_74, null, 1.5);
    angela.talk(`Oh ${tom.name}!`);
    mc.think(`That's awkward.`);
    mc.think(`It's like she completely forgot he was here this whole time.`);

    angela.talk(`Can you... Come closer?`);
    tom.talk(`Yeah... But can you wipe your face first?`);
    angela.talk(`Oh! Sorry.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_75, { wait: 0.7 });
    ImageClass.setImage(images.v8.V8VanessaMCBeach_76, { wait: true });
    doWaitImageByTime(images.v8.V8VanessaMCBeach_78);

    angela.talk(`Are you mad at me?`);
    tom.talk(`Should I be?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_77);
    angela.talk(`No...?`);
    angela.talk(`You didn't say stop, so I thought it was ok...`);
    angela.talk(`I guess I lost myself in the moment.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_79);
    vanessa.talk(`You did good!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_80);
    tom.talk(`So why does it feel so bad?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_81);
    vanessa.talk(`It will feel better, trust me.`);
    vanessa.talk(`I told you it's not for everyone.`);
    vanessa.talk(`But you made it through; that was the hardest step.`);
    vanessa.talk(`You should be proud of yourself.`);

    vanessa.talk(`And you should also be proud of ${angela.name}.`);
    vanessa.talk(`She did this for you.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_79);
    tom.talk(`I guess...`);

    doWaitImageByTime(images.v8.V8VanessaMCBeach_82, null, 2);
    vanessa.talk(`We'll leave you guys to it.`);
    vanessa.talk(`Do you know your way back from here?`);
    tom.talk(`I do.`);
    await endReplay(replayScenesList.v8McVanessaAngelaBeach);

    return jump(V8VanessaMCBeach_End, "V8VanessaMCBeach_End");
};
export const V8VanessaMCBeach_DontFuckAngela = async (): Promise<any> => {
    mc.think(`I can't do it.`);
    mc.think(`Vanessa manipulated her so much she isn't thinking straight.`);
    mc.think(`She actually believes Vanessa is helping her.`);
    vanessa.talk(`Ahem ahem!!!`);
    mc.think(`I'll just stay put...`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_49);
    vanessa.talk(`Hold that thought.`);

    // going with MC to the MC and pulling him to the side.
    ImageClass.setImage(images.v8.V8VanessaMCBeach_88);
    vanessa.talk(`Do you want to get shanked?`);
    // side

    ImageClass.setImage(images.v8.V8VanessaMCBeach_89);
    vanessa.talk(`Honey, can we talk privately for a minute?`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_90, { shake: true, duration: 0 });
    mc.think(`Ouch! Fuck!`);
    doWaitImageByTime(images.v8.V8VanessaMCBeach_91);
    vanessa.talk(`What the fuck is wrong with you?`);
    vanessa.talk(`I've loosened her up so much you can literally slide in.`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_93);
    mc.talk(`I don't feel good about this.`);
    mc.talk(`She is so nice, I don't like the way you manipulated her.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_92);
    vanessa.talk(`I didn't say anything that isn't true!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_93);
    mc.talk(`Still. She is too naive. We'll have to find another way.`);
    // Looking back and they got dressed.
    doWaitImageByTime(images.v8.V8VanessaMCBeach_94);
    vanessa.talk(`Fuck!!!`);

    ImageClass.setImage(images.v8.V8VanessaMCBeach_95);
    vanessa.talk(`Look at what you did!`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_96, { wait: true });

    ImageClass.setImage(images.v8.V8VanessaMCBeach_97);
    vanessa.talk(`Well, there is no point in staying here now!`);
    vanessa.talk(`Let's just get the fuck out of here.`);
    ImageClass.setImage(images.v8.V8VanessaMCBeach_98);
    return jump(V8VanessaMCBeach_End, "V8VanessaMCBeach_End");
};
export const V8VanessaMCBeach_End = async (): Promise<any> => {
    // SoundClass.stopMusic(music.V8VanessaMCAngelaBeach);
    return jump(V8VanessaMCBeachAfter, "V8VanessaMCBeachAfter");
};